import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/logo.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewTask = _resolveComponent("NewTask")!
  const _component_TaskList = _resolveComponent("TaskList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      alt: "Vue logo",
      src: _imports_0
    }, null, -1)),
    _createElementVNode("div", null, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Task List Application using Vue, TypeScript and Vuex", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, " This is a task list application using Vue, TypeScript, and Vuex with SCSS styles. It supports gamification like levels and experience points (XP). ", -1)),
      _createVNode(_component_NewTask),
      _createVNode(_component_TaskList)
    ])
  ], 64))
}